import script from "./dummyData4.vue?vue&type=script&lang=js"
export * from "./dummyData4.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__